<template>
  <div class="bgf5 nav">
    <div class="flex justify-content-space-between" style="padding: 0;">
      <div class="f14 flex align-items-center">
        <van-icon :name="require('../assets/dingwei-icon.png')" size="16px" style="line-height: 0;" color="#0F6EEA" />
        <a href="javascript:void(0)">
          <span class="c0F6EEA">{{ _truncature(CustomerInfo&&CustomerInfo.CustomerName,15) }}</span>
          <div class="c222 ihover" style="display: inline-block;" @click="onSwitchStore">【切换门店】</div>
        </a>
        <a href="javascript:void(0)" class="ml20" @click.stop="loginOut">
          <span class="c999 ihover">退出</span>
        </a>
      </div>
      <div class="f14 c222">
        <ul style="margin-bottom: 0;">
          <li>
            <router-link :to="{name:LinkTypeCode.Mine}" tag="a" target="_blank">
              <span>个人中心</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:LinkTypeCode.MyOrder}" tag="a" target="_blank">
              <span>我的订单</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:LinkTypeCode.Msg}" tag="a" target="_blank">
              <span>我的消息</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:LinkTypeCode.MyCollection}" tag="a" target="_blank">
              <span>我的收藏</span>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:LinkTypeCode.HelpCenter}" tag="a" target="_blank">
              <span>帮助中心</span>
            </router-link>
          </li>
          <li>
            <!-- <router-link to="LiveRoom" tag="a" target="_blank"> -->
            <!-- <span>直播间</span> -->
            <!-- </router-link> -->
            <a :href="liveRoomUrl" target="_blank">直播间</a>
          </li>
          <li class="relative" @mouseover="qrcodeShow = true" @mouseleave="qrcodeShow = false">
            <router-link :to="{name:LinkTypeCode.DownLoad}" tag="a" target="_blank">
              <van-icon :name="require('../assets/phone-icon.png')" size="12px" color="#0F6EEA" style="position: relative; top: -2px;" />
              <span>手机版</span>
            </router-link>
            <transition name="fade">
              <div v-if="qrcodeShow" class="qrcode">
                <van-icon :name="require('@/assets/download/qrcode.png')" size="120px" />
              </div>
            </transition>
          </li>
          <!-- <li class="c0F6EE9 m17 fw600">服务热线：{{lang.Basic.ServicePhone}}</li> -->
        </ul>
      </div>
    </div>
    <SwitchStore ref="SwitchStore" @confirm="onConfirm" />
    <!-- 对话框 -->
    <iDialog ref="iDialogref" msg="确认退出登录" confirm-btn-text="确认" cancel-btn-text="取消" @confirm="confirmDialog" />
  </div>
</template>
<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import { LinkTypeCode } from '../dictionary/base'
export default {
  name: 'Header',
  mixins: [BaseMixin],
  data() {
    return {
      LinkTypeCode,
      CustomerInfo: null,
      qrcodeShow: false,
      liveRoomUrl: ''
    }
  },
  mounted() {
    this.getCustomerInfo()
    // 获取首页直播间跳转路径
    this.getHomePageShowData()
  },
  methods: {
    // 获取直播跳转
    async getHomePageShowData() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_basedata/HomePage/GetAdvertisementsNavigations?enumTerminal=1'
      )
      this.$hys.clearLoading()
      if (res.IsSuccess) {
        if (res.Data.Navigations.length > 0) {
          res.Data.Navigations.map(oo => {
            if (oo.LinkType == 99 && oo.LinkValue.indexOf('vzan') > 0) {
              this.liveRoomUrl = oo.LinkValue
            }
          })
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 获取客户信息
    async getCustomerInfo() {
      // this.$hys.openLoading();
      const res = await this.getAction('/api_customers/Customer/CustomerContactDetail')
      // this.$hys.clearLoading();
      if (res.IsSuccess && res.Data) {
        this.CustomerInfo = res.Data
        this.$store.commit('_setIsSubAccount', res.Data.IsSub || false)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },

    onSwitchStore() {
      this.$refs.SwitchStore.Show(null)
    },
    // 退出登录
    loginOut() {
      this.$refs.iDialogref.iShow()
    },
    confirmDialog() {
      this.auth.removeLoginDatas()
      setTimeout(() => { this.$router.push('/Login') }, 500)
    },
    // 更新用户认证等信息
    async updateCustomOtherInfo() {
      const res = await this.getAction('/api_customers/Customer/GetCustomerOtherInfo', { id: this.$auth.getCustomerId() })
      if (res.IsSuccess) {
        this.$auth.setCustomerOtherInfo(res.Data)
      }
    },
    async onConfirm(cums) {
      this.CustomerInfo = cums

      // 更新资料
      await this.updateCustomOtherInfo()

      this.$router.go(0)
    }
  }
}
</script>
<style lang="less" scoped>
.nav {
  line-height: 36px;

  > div {
    margin: 0 auto;
    width: 1180px;

    ul li {
      display: inline-block;
      margin-right: 15px;

      > a span {
        border-right: 1px solid #E5E5E5;
        padding-right: 15px;
        color: #222222;

        &:hover {
          color: #0F6EE9;
        }
      }

      &:last-child {
        margin-right: 0;

        > a span {
          margin-left: 2px;
          border-right: 0;
          padding-right: 0;
        }
      }
    }
  }
}

.m17 {
  margin-left: 12px;
}

.qrcode {
  position: absolute;
  top: 36px;
  left: -50px;
  z-index: 6;
  width: 120px;
  height: 120px;
  background: #E8E8E8;

  img {
    vertical-align: initial;
  }
}
</style>
